<script>
import {cloneDeep} from "lodash";
import {mapState} from "vuex";
import Swal from "sweetalert2";

export default {
  name: "pricingPrices",
  data() {
    return {
      prices: [],
      price: {
        new: {
          name: 'Price 1',
          total_net_price: '',
          currency: 'EUR',
          price_package_items: [
            {
              post_type: '',
              social_network: '',
              quantity: 1,
              net_price: '',
              giveaway: false,
              event: false
            }
          ]
        },
        edit: {
          price_package_items: [
            {
              post_type: '',
              social_network: '',
              quantity: 1,
              net_price: '',
              giveaway: false,
              event: false
            }
          ]
        },
      },
      options: {
        post_type: {}
      },
      blankValue: {
        value: '',
        text: 'Please select an option'
      },
      postTypes: {
        instagram_posts: ['photo_post', 'video_post', 'IGTV_post', 'story', 'story_series'],
        facebook_posts: ['photo_post', 'video_post'],
        youtube_posts: ['dedicated_video', 'product_placement_video'],
        blog_posts: ['native_text', 'pr_text']
      },
      showModal: {
        new: false,
        edit: false
      },
      error: {
        new: {
          social_network: false,
          post_type: false,
          net_price: false,
          exist: false
        },
        edit: {
          social_network: false,
          post_type: false,
          net_price: false,
          exist: false
        }
      }
    };
  },
  watch: {
    pricelist: {
      handler(newValue) {
        this.prices = cloneDeep(newValue);
        this.prices.forEach(price => this.$set(price, 'existsInPackage', this.doespriceExistInPackage(price)));
        this.sortByNetwork();
        this.price.new.name = `Package ${this.prices.length + 1}`;
      },
      deep: true
    },
    pricePackages: {
      handler(newValue) {
        this.prices.forEach(price => this.$set(price, 'existsInPackage', this.doespriceExistInPackage(price)));
      },
      deep: true
    }
  },
  computed: {
    ...mapState('user', {
      user: (state) => state.user
    }),
    ...mapState('pricing', {
      pricePackages: (state) => state.pricePackages,
      pricelist: (state) => state.pricelist
    }),
    editTitle() {
      if (!this.price.edit.name) {
        return ''
      } else {
        return `Edit ${this.price.edit.price_package_items[0].social_network.charAt(0).toUpperCase() + this.price.edit.price_package_items[0].social_network.slice(1)} ${this.price.edit.price_package_items[0].post_type.replace(/_/g, ' ')} price`
      }
    },
    availableSocialNetworks() {
      const available = []
      Object.keys(this.user.social_network_accounts).forEach(key => {
        if (['instagram', 'facebook', 'youtube', 'blog'].includes(key)
            && this.user.social_network_accounts[key]) {
          available.push(key);
        }
      })
      return available
    }
  },
  created() {
    this.prices = cloneDeep(this.pricelist);
    this.prices.forEach(price => this.$set(price, 'existsInPackage', this.doespriceExistInPackage(price)));
    this.sortByNetwork();
    this.price.new.name = `Package ${this.prices.length + 1}`;

    // fill options
    Object.keys(this.postTypes).forEach(category => {
      this.options.post_type[category] = [this.blankValue, ...this.postTypes[category].map(item => {
        return {
          text: item.charAt(0).toUpperCase() + item.slice(1).replace(/_/g, " "),
          value: item
        };
      })];
    })
  },
  methods: {
    resetForm(type) {
      this.error[type] = {
        form: false,
        price: false,
        exist: false
      };
      if (type === 'new') {
        this.price[type] = {
          name: `Package ${this.prices.length + 1}`,
          total_net_price: '',
          currency: 'EUR',
          price_package_items: [
            {
              post_type: '',
              social_network: '',
              quantity: 1,
              net_price: '',
              giveaway: false,
              event: false
            }
          ]
        }
      } else {
        this.price[type] = {
          price_package_items: [
            {
              giveaway: false,
              event: false
            }
          ]
        }
      }
    },
    openModal(type, price) {
      this.showModal[type] = true;
      if (type === 'edit') {
        this.price[type] = cloneDeep(price);
      }
    },
    isPriceValid(type) {
      let isValid = true;
      if (this.price[type].price_package_items[0].net_price === '' ||
          (!/^\d+$/.test(this.price[type].price_package_items[0].net_price.toString()) ||
              this.price[type].price_package_items[0].net_price <= 0)) {
        this.error[type].net_price = true;
        isValid = false;
      }
      if (type === 'new') {
        // check for empty fields
        if (this.price[type].price_package_items[0].social_network === '') {
          this.error[type].social_network = true;
          isValid = false;
        }
        if (this.price[type].price_package_items[0].post_type === '') {
          this.error[type].post_type = true;
          isValid = false;
        }
        // if fields are valid check if there is same price item
        const exists = this.prices.some(price => {
          return price.price_package_items[0].social_network === this.price[type].price_package_items[0].social_network &&
              price.price_package_items[0].post_type === this.price[type].price_package_items[0].post_type &&
              price.price_package_items[0].giveaway === this.price[type].price_package_items[0].giveaway &&
              price.price_package_items[0].event === this.price[type].price_package_items[0].event;
        });
        if (exists) {
          this.error[type].exist = true;
          isValid = false;
        }
      } else {
        if (!(/^\d+$/.test(this.price[type].total_net_price.toString()) && this.price[type].total_net_price > 0)) {
          isValid = false;
        }
      }

      return isValid;
    },
    ok(bvModalEvt) {
      if (this.price.edit.name) {
        this.updatePrice(bvModalEvt);
      } else {
        this.createPrice(bvModalEvt);
      }
    },
    async createPrice(bvModalEvt) {
      if (this.isPriceValid('new')) {
        try {
          await this.$store.dispatch('pricing/createPriceItem', {payload: this.price.new, type: 'pricelist'});
        } catch (err) {
          console.log(err);
        } finally {
          this.resetForm('new');
          this.sortByNetwork();
        }
      } else {
        bvModalEvt.preventDefault();
      }
    },
    async updatePrice(bvModalEvt) {
      if (this.isPriceValid('edit')) {
        try {
          await this.$store.dispatch('pricing/updatePriceItem', {
            packageId: this.price.edit._id,
            payload: this.price.edit,
            type: 'pricelist'
          });
        } catch (err) {
          console.log(err)
        }
        this.resetForm('edit');
      } else {
        this.editPackageFormError = true;
        bvModalEvt.preventDefault();
      }
    },
    async deletePrice(price) {
      // price item can be removed only when its removed from all Price Packages
      if (this.doespriceExistInPackage(price)) {
        this.deleteError = true;
      } else {
        try {
          await this.$store.dispatch('pricing/deletePricePackage', {packageId: price._id, type: 'pricelist'});
        } catch (err) {
          console.log(err)
        }
      }
    },
    title(type) {
      if (type === 'new') {
        return 'New price item'
      } else {
        return this.editTitle;
      }
    },
    socialNetworkChanged(type) {
      this.error[type].social_network = false;
      this.price[type].price_package_items[0].post_type = '';
    },
    onPriceInput(type) {
      this.error[type].price = false;
      this.error[type].form = false;
      this.error[type].exist = false;
      this.price[type].total_net_price = this.price[type].price_package_items[0].net_price;
    },
    sortByNetwork() {
      this.prices.sort((a, b) => {
        if (a.price_package_items[0].social_network > b.price_package_items[0].social_network) {
          return -1;
        }
        if (a.price_package_items[0].social_network < b.price_package_items[0].social_network) {
          return 1;
        }
        return 0;
      });
    },
    doespriceExistInPackage(price) {
      return this.pricePackages.some(pricePackage => {
        return pricePackage.price_package_items.some(item => {
          return item.giveaway === price.price_package_items[0].giveaway &&
              item.event === price.price_package_items[0].event &&
              item.post_type === price.price_package_items[0].post_type &&
              item.social_network === price.price_package_items[0].social_network;
        });
      });
    },
    async switchOnDemand() {
      const result = await Swal.fire({
        title: 'Do you want switch back to "on-demand" pricing?',
        text: "Your prices and price packages will be deleted.",
        icon: "warning",
        showCancelButton: true,
        // confirmButtonColor: "#f46a6a",
        // cancelButtonColor: "#868585",
        confirmButtonText: "Yes"
      })
      if (result.value) {
        this.$store.dispatch('user/switchToOnDemandPricing');
      }
    },
  }
}
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12 d-flex justify-content-between">
        <button @click="switchOnDemand" class="btn btn-outline-secondary my-4">
          <i class="fas fa-undo mr-1" style="font-size: 10px; vertical-align: middle;"></i>On-demand pricing
        </button>
        <button @click="showModal.new = true" class="btn btn-primary my-4">
          <i class="bx bx-plus" style="font-size: 16px; vertical-align: middle;"></i>New price
        </button>
      </div>
    </div>
    <div v-if="prices.length" class="d-none d-md-block py-1 px-2 mb-2 pricing-header-row">
      <div class="row align-items-center">
        <div class="col-12 col-md text-center">
          <p class="text-muted mb-0">{{ $t('Platform') }}</p>
        </div>
        <div class="col-6 col-md text-center">
          <p class="text-muted mb-0">{{ $t('Post type') }}</p>
        </div>
        <div class="col text-center">
          <p class="text-muted mb-0">{{ $t('Giveaway') }}</p>
        </div>
        <div class="col text-center">
          <p class="text-muted mb-0">{{ $t('Event') }}</p>
        </div>
        <div class="col-6 col-md text-center">
          <p class="text-muted mb-0">{{ $t('Price') }}</p>
        </div>
        <div class="col-12 mt-3 mt-md-0 col-md-auto">
          <div class="button-container text-right">
            <button class="btn btn-outline-warning btn-sm mr-2 invisible"><i
                class="bx bxs-edit-alt mr-1 align-middle font-size-16"></i> Edit
            </button>
            <button class="btn btn-outline-danger btn-sm invisible"><i
                class="bx bx-x mr-1 align-middle font-size-16"></i> Remove
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-for="(price, key) in prices" :key="price._id" class="tab-section p-2 mb-2">
      <div class="row align-items-center">
        <div class="order-1 col-4 col-md text-center">
          <div class="social-image-container d-flex align-items-center justify-content-md-center">
            <img v-if="price.price_package_items[0].social_network === 'instagram'"
                 src="@/assets/images/brands/instagram.png" class="img-fluid" style="width:28px;" alt="">
            <img v-if="price.price_package_items[0].social_network === 'facebook'"
                 src="@/assets/images/brands/facebook.png" class="img-fluid" style="width:28px;" alt="">
            <img v-if="price.price_package_items[0].social_network === 'youtube'"
                 src="@/assets/images/brands/youtube.png" class="img-fluid" style="width:28px;" alt="">
            <img v-if="price.price_package_items[0].social_network === 'blog'"
                 src="@/assets/images/brands/analytics-logo.png" class="img-fluid" style="width:28px;" alt="">
          </div>
        </div>
        <div class="col-6 order-4 order-md-2 mt-2 mt-md-0 col-md text-center">
          <p class="text-muted d-md-none mb-1">{{ $t('Post type') }}</p>
          <h5 class="mb-0"> {{
              (price.price_package_items[0].post_type.charAt(0).toUpperCase() + price.price_package_items[0].post_type.slice(1)).replace(/_/g, " ")
            }} </h5>
        </div>
        <div class="col-12 col-md order-6 order-md-3 mt-2 mt-md-0 text-center">
          <p class="text-muted d-md-none mb-1">{{ $t('Giveaway') }}</p>
          <span v-if="price.price_package_items[0].giveaway"
                class="badge badge-soft-success font-size-12 ml-1 align-bottom">Yes</span>
          <span v-else class="badge badge-soft-warning font-size-12 ml-1 align-bottom">No</span>
        </div>
        <div class="col-12 col-md order-6 order-md-3 mt-2 mt-md-0 text-center">
          <p class="text-muted d-md-none mb-1">{{ $t('Event') }}</p>
          <span v-if="price.price_package_items[0].event"
                class="badge badge-soft-success font-size-12 ml-1 align-bottom">Yes</span>
          <span v-else class="badge badge-soft-warning font-size-12 ml-1 align-bottom">No</span>
        </div>
        <div class="col-6 order-5 order-md-4 col-md mt-2 mt-md-0 text-center">
          <p class="text-muted d-md-none mb-1">{{ $t('Price') }}</p>
          <h5 class="mb-0"> {{ price.price_package_items[0].net_price.toLocaleString() }} <span style="font-size: 0.85em;">&euro;</span></h5>
        </div>
        <div class="order-2 order-md-5 col-8 mt-0 col-md-auto">
          <div class="button-container text-right">
            <button @click="openModal('edit', price)" class="btn btn-outline-warning btn-sm mr-2">
              <i class="bx bxs-edit-alt mr-1 align-middle font-size-16"></i>
              Edit
            </button>
            <span
                v-b-tooltip.hover="price.existsInPackage ? `You can't remove price item that is used in any price package.` : ''">
                            <button @click="deletePrice(price)"
                                    :disabled="price.existsInPackage"
                                    class="btn btn-outline-danger btn-sm">
                                <i class="bx bx-x mr-1 align-middle font-size-16"></i>
                                    Remove
                            </button>
                        </span>
          </div>
        </div>
      </div>
    </div>

    <!--modals-->
    <b-modal v-for="type in ['new', 'edit']"
             :key="type"
             :ref="`${type}Modal`"
             @cancel="resetForm(type)"
             @ok="ok"
             v-model="showModal[type]"
             :title="title(type)"
             centered>
      <div>
        <div v-if="type === 'new'" class="form-group form-row align-items-center">
          <label class="col-5 col-form-label position-relative">
            Platform:
            <span class="label-explanation">* You can define prices for the connected social networks only</span>
          </label>
          <div class="col-7 col-form-label">
            <b-form-select :class="{ 'is-invalid': error.new.social_network }" class="text-capitalize"
                           @input="socialNetworkChanged(type)" v-model="price.new.price_package_items[0].social_network"
                           :options="[blankValue, ...availableSocialNetworks]"></b-form-select>
          </div>
          <label v-if="price.new.price_package_items[0].social_network" class="col-5 col-form-label">Post type:</label>
          <div v-if="price.new.price_package_items[0].social_network" class="col-7 col-form-label">
            <b-form-select :class="{ 'is-invalid': error.new.post_type }"
                           @input="error.new.post_type = false"
                           v-model="price.new.price_package_items[0].post_type"
                           :options="options.post_type[`${price.new.price_package_items[0].social_network}_posts`]"/>
          </div>
<!--          <span class="label-explanation">*You can define prices for the connected social networks only</span>-->
        </div>
        <div class="form-group form-row align-items-center">
          <label class="col-5 col-form-label">Price in 	&euro;:</label>
          <div class="col-7 col-form-label">
            <input type="number"
                   min="1"
                   v-model.number="price[type].price_package_items[0].net_price"
                   @input="onPriceInput(type)"
                   class="form-control"
                   :class="{ 'is-invalid': error[type].price }"/>
          </div>
          <div class="offset-5 col-7 col-form-label">
            <b-form-checkbox
                :id="`checkbox-${type}`"
                v-model="price[type].price_package_items[0].giveaway"
                :name="`checkbox-${type}`"
                :value="true"
                :unchecked-value="false"
            >
              Includes giveaway
            </b-form-checkbox>
          </div>
          <div class="offset-5 col-7 col-form-label">
            <b-form-checkbox
                :id="`checkbox-${type}-event`"
                v-model="price[type].price_package_items[0].event"
                :name="`checkbox-${type}-event`"
                :value="true"
                :unchecked-value="false"
            >
              Includes event
            </b-form-checkbox>
          </div>
        </div>
      </div>
      <div class="text-center">
        <span v-if="error[type].exist" class="text-danger"> Price item already exists. </span>
      </div>
    </b-modal>

  </div>
</template>

<style scoped>
.tab-section:last-child {
  margin-bottom: 0 !important;
}

.tab-section h5 {
  font-size: 0.9rem;
}

.pricing-header-row {
  border-bottom: 2px solid #f6f6f6;
  border-radius: 2px;
}

.social-image-container {
  height: 30px;
}

  .label-explanation {
    position: absolute;
    left: 4px;
    top: 26px;
    font-size: 11px;
    color: #909398;
    /*font-style: italic;*/
  }
</style>
